import { dequal } from "dequal";

/**
 * Determine if two values of the same type are deep equal
 * @function isEqual
 * @param {unknown} a first value
 * @param {unknown} b second value
 * @returns {boolean} true if values are the same
 */
export const isEqual = <T>(a: T, b: T): boolean => dequal(a, b);
